module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "large-8 columns left",
    attrs: {
      "id": "home-page"
    }
  }, [_c('headline'), _vm._v(" "), _c('newsListPanel')], 1), _vm._v(" "), _c('div', {
    staticClass: "large-4 columns right"
  }, [(_vm.isLogged) ? _c('activityPanel') : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('latestMatchesPanel') : _vm._e(), _vm._v(" "), (!_vm.isLogged) ? _c('loginPanel') : _vm._e(), _vm._v(" "), (!_vm.isLogged) ? _c('registerPanel') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-343ed9d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue
// module id = 731
// module chunks = 0